import React from 'react'
import PropTypes from 'prop-types'

import ArticleDownload from '@/component/Primitive/ArticleDownload'

const ArticleLayoutDownloadWidget = ({ article }) => {
  if (!article || !article.downloadUrl) return null

  return (
    <ArticleDownload href={article.downloadUrl}>Download Now</ArticleDownload>
  )
}

ArticleLayoutDownloadWidget.propTypes = {
  article: PropTypes.shape({
    downloadUrl: PropTypes.string
  })
}

export default ArticleLayoutDownloadWidget
